export const SET_USER_CONNECTION_STATUS = "set-user-connection-status";
export const SET_USER_CONNECTION_IS_FETCHING = "set-user-connection-status-is-fetching";
